import { Grid } from '@mui/material';
import type { HistoryFilter } from 'components/History';
import React from 'react';
import { SparkDateRangePicker } from 'sharedComponents/UI';
import moment from 'moment';
import { useSparkBuilderStore } from 'stores';
import SparkRunsHistory from 'components/sparkRunHistory/SparkRunsHistory';

function SparkBuilderHistory() {
  const sparkID = useSparkBuilderStore((store) => store.sparkID);

  const [historyFilter, setHistoryFilter] = React.useState<HistoryFilter>({
    sparkIDs: [sparkID],
    dateRange: {
      startDate: moment().subtract(1, 'month'),
      endDate: moment(),
    },
  });

  return (
    <Grid container gap={2}>
      <SparkDateRangePicker
        historyFilter={historyFilter}
        setHistoryFilter={setHistoryFilter}
      />
      <SparkRunsHistory
        sparkID={sparkID}
        historyFilter={historyFilter}
        paginatedQuery={{ pageNumber: 1, pageSize: 5 }}
      />
    </Grid>
  );
}

export default SparkBuilderHistory;
